import React from 'react';
import classNames from 'classnames';

import { GatsbyImage } from 'gatsby-plugin-image';
import RichText from '../../RichText/RichText';

import { createMetaFieldsMap } from '../../../utils';

const ns = `product-benefits`;

const Benefits = ({
	product,
	globalSettings,
}) => {
	const createBenefitsMap = (_benefits = []) => {
		const output = {};

		_benefits?.forEach(({
			name,
			icon,
			description,
		}) => {
			output[name?.toLowerCase()] = {
				icon,
				description,
			};
		});

		return output;
	};

	const benefitsMap = createBenefitsMap(globalSettings?.productBenefits);
	const metafieldsMap = createMetaFieldsMap(product?.metafields);

	const productBenefits = (() => {
		try {
			if (metafieldsMap?.custom?.benefits) {
				return JSON.parse(metafieldsMap.custom.benefits);
			}
		} catch (e) {
			console.error(e); // eslint-disable-line
		}

		return false;
	})();

	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	if (!productBenefits?.length > 0) return null;

	return (
		<ul className={rootClassnames}>
			{productBenefits.map(benefit => {
				if (typeof benefit !== 'string') return null;
				const key = benefit?.toLowerCase().trim();
				const benefitFromMap = benefitsMap[key];

				if (!benefitFromMap) return null;

				return (
					<li key={benefit}>
						{benefitFromMap?.icon && (
							<span aria-hidden>
								<GatsbyImage
									alt={benefitFromMap?.icon?.title}
									image={benefitFromMap?.icon?.gatsbyImageData}
									loading={'lazy'}
								/>
							</span>
						)}
						{benefitFromMap?.description?.raw && (
							<RichText fieldData={benefitFromMap.description} />
						)}
					</li>
				);
			})}
		</ul>
	);
};

export default Benefits;
